<template>
    <JourneyLayout>
        <WaitingAnimation></WaitingAnimation>
    </JourneyLayout>
</template>

<script setup>

import JourneyLayout from "@/components/journey/JourneyLayout.vue";
import WaitingAnimation from '@/components/layout/WaitingAnimation';
</script>
